import { render, staticRenderFns } from "./deanHeaderProfile.vue?vue&type=template&id=54e402ad&scoped=true"
import script from "./deanHeaderProfile.vue?vue&type=script&lang=ts"
export * from "./deanHeaderProfile.vue?vue&type=script&lang=ts"
import style0 from "./deanHeaderProfile.vue?vue&type=style&index=0&id=54e402ad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e402ad",
  null
  
)

export default component.exports